import { useState } from "react";

import {
    ChevronDown,
    FileText,
    FileType,
    HardDrive,
    FolderOpen,
    Shield,
    Calendar,
    Image
} from "lucide-react";

import formatFileSize,{
    formatDate
} from "../../utils/formatFileSize";

import MediaInfoRow
from "./MediaInfoRow";

export default function MediaInfo({

    media

}){

    const [

        open,

        setOpen

    ] = useState(false);

    if(!media){

        return null;

    }

    return(

        <div className="media-info-card">

            <div

                className="media-section-title"

                onClick={()=>

                    setOpen(

                        previous=>!previous

                    )

                }

            >

                <div className="media-section-left">

                    <ChevronDown

                        size={18}

                        className={

                            open

                            ? "section-chevron open"

                            : "section-chevron"

                        }

                    />

                    <FileText size={18}/>

                    <span>

                        File Information

                    </span>

                </div>

            </div>

            <div

                className={

                    open

                    ? "media-info-body open"

                    : "media-info-body"

                }

            >

                <MediaInfoRow
                    icon={<FileText size={16}/>}
                    label="Name"
                    value={media.original_name}
                />

                <MediaInfoRow
                    icon={<FileType size={16}/>}
                    label="Type"
                    value={media.mime_type}
                />

                <MediaInfoRow
                    icon={<FileType size={16}/>}
                    label="Extension"
                    value={media.extension?.toUpperCase()}
                />

                <MediaInfoRow
                    icon={<HardDrive size={16}/>}
                    label="Size"
                    value={formatFileSize(media.size_bytes)}
                />

                <MediaInfoRow
                    icon={<FolderOpen size={16}/>}
                    label="Folder"
                    value={media.folder}
                />

                <MediaInfoRow
                    icon={<Shield size={16}/>}
                    label="Visibility"
                    badge
                    value={media.visibility}
                />

                <MediaInfoRow
                    icon={<Calendar size={16}/>}
                    label="Uploaded"
                    value={formatDate(media.created_at)}
                />

                {

                    media.width &&
                    media.height &&

                    <MediaInfoRow
                        icon={<Image size={16}/>}
                        label="Dimensions"
                        value={`${media.width} × ${media.height}`}
                    />

                }

            </div>

<style>{`

.media-info-card{

    background:#FFF;

    border:1px solid #E5E7EB;

    border-radius:18px;

    padding:22px;

    box-shadow:0 1px 2px rgba(15,23,42,.04);

}

.media-section-title{

    display:flex;

    align-items:center;

    justify-content:space-between;

    cursor:pointer;

    user-select:none;

}

.media-section-left{

    display:flex;

    align-items:center;

    gap:10px;

    font-size:17px;

    font-weight:700;

    color:#0F172A;

}

.media-section-left svg{

    color:#2563EB;

}

.section-chevron{

    color:#94A3B8 !important;

    transition:transform .2s ease;

    transform:rotate(-90deg);

}

.section-chevron.open{

    transform:rotate(0deg);

}

.media-info-body{

    overflow:hidden;

    max-height:0;

    opacity:0;

    transition:

        max-height .25s ease,

        opacity .2s ease;

}

.media-info-body.open{

    max-height:700px;

    opacity:1;

    margin-top:18px;

}

`}</style>

        </div>

    );

}